import { generateMetadata, MetaDataEntity } from './utils'

const MetaData: MetaDataEntity = {
  title: 'AviaGames | Contact Support & FAQs',
  description:
    'Need help? Contact support at AviaGames with player FAQs and customer service. Find answers and support anytime!',
  keywords: ['contact support'],
  path: '/support',
}

export const SupportMetaData = generateMetadata(MetaData)
